import React from "react";
import uniqid from "uniqid";

import "./DropdownFilter.css";
import FilterLabel from "../FilterLabel/FilterLabel";

export type Props<TOption> = {
    title?: string;
    onChange: (value: TOption | null) => void;
    value: TOption | null;
    extractTitle: (item: TOption) => string;
    extractValue: (item: TOption) => string;
    options: TOption[];
    placeholder?: string;
    disabled?: boolean;
    emptyOption?: boolean;
    sort?: boolean;
    testId?: string;
};

function DropdownFilter<TOption>(props: Props<TOption>) {
    const id = uniqid("DropdownFilter-");
    const sortByTitle = (a: TOption, b: TOption) => props.extractTitle(a).localeCompare(props.extractTitle(b));
    const options = props.sort ? props.options.sort(sortByTitle) : props.options;

    return (
        <span className="DropdownFilter">
            {props.title ? (
                <FilterLabel id={id} title={props.title} />
            ) : null}

            <select
                id={id}
                className="DropdownFilter-select"
                onChange={e => props.onChange(props.options.find(option => props.extractValue(option) === e.target.value) ?? null)}
                value={props.value ? props.extractValue(props.value) : ""}
                disabled={props.disabled || props.options.length === 0}
                data-testid={props.testId}
            >
                {props.emptyOption ? (
                    <option value="" style={{ color: "#787878" }}>{props.placeholder}</option>
                ) : null}
                {options.map((option, i) => (
                    <option value={props.extractValue(option)} key={props.extractValue(option)}>
                        {props.extractTitle(option)}
                    </option>
                ))}
            </select>
        </span>
    );
};

export default DropdownFilter;
